/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssetDocumentArea,
  AssetInventoryDocumentResponse,
  DocumentResponse,
  MarkAssetInventoryDocumentReadRequest,
  ProblemDetails,
} from '../models/index';
import {
    AssetDocumentAreaFromJSON,
    AssetDocumentAreaToJSON,
    AssetInventoryDocumentResponseFromJSON,
    AssetInventoryDocumentResponseToJSON,
    DocumentResponseFromJSON,
    DocumentResponseToJSON,
    MarkAssetInventoryDocumentReadRequestFromJSON,
    MarkAssetInventoryDocumentReadRequestToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface DeleteAssetInventoryAssetDocumentRequest {
    clientId: string;
    area: AssetDocumentArea;
    documentId: string;
}

export interface DeleteAssetInventoryBankStatementRequest {
    clientId: string;
    documentId: string;
}

export interface DeleteAssetInventoryDependantDocumentRequest {
    clientId: string;
    documentId: string;
}

export interface DeleteAssetInventoryExpenseProofRequest {
    clientId: string;
    documentId: string;
}

export interface DeleteAssetInventoryIncomeProofRequest {
    clientId: string;
    documentId: string;
}

export interface DeleteAssetInventoryOwnClaimDocumentRequest {
    clientId: string;
    documentId: string;
}

export interface GetAssetInventoryAssetDocumentsRequest {
    clientId: string;
    area: AssetDocumentArea;
}

export interface GetAssetInventoryBankStatementsRequest {
    clientId: string;
}

export interface GetAssetInventoryDependantDocumentsRequest {
    clientId: string;
}

export interface GetAssetInventoryExpenseProofsRequest {
    clientId: string;
}

export interface GetAssetInventoryIncomeProofsRequest {
    clientId: string;
}

export interface GetAssetInventoryOwnClaimDocumentsRequest {
    clientId: string;
}

export interface MarkAssetInventoryDocumentReadOperationRequest {
    clientId: string;
    documentId: string;
    markAssetInventoryDocumentReadRequest: MarkAssetInventoryDocumentReadRequest;
}

export interface UploadAssetInventoryAssetDocumentRequest {
    clientId: string;
    area: AssetDocumentArea;
}

export interface UploadAssetInventoryBankStatementRequest {
    clientId: string;
}

export interface UploadAssetInventoryDependantDocumentRequest {
    clientId: string;
}

export interface UploadAssetInventoryExpenseProofRequest {
    clientId: string;
}

export interface UploadAssetInventoryIncomeProofRequest {
    clientId: string;
}

export interface UploadAssetInventoryOwnClaimDocumentRequest {
    clientId: string;
}

/**
 * AssetInventoryDocumentsApi - interface
 * 
 * @export
 * @interface AssetInventoryDocumentsApiInterface
 */
export interface AssetInventoryDocumentsApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {AssetDocumentArea} area 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    deleteAssetInventoryAssetDocumentRaw(requestParameters: DeleteAssetInventoryAssetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteAssetInventoryAssetDocument(requestParameters: DeleteAssetInventoryAssetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    deleteAssetInventoryBankStatementRaw(requestParameters: DeleteAssetInventoryBankStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteAssetInventoryBankStatement(requestParameters: DeleteAssetInventoryBankStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    deleteAssetInventoryDependantDocumentRaw(requestParameters: DeleteAssetInventoryDependantDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteAssetInventoryDependantDocument(requestParameters: DeleteAssetInventoryDependantDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    deleteAssetInventoryExpenseProofRaw(requestParameters: DeleteAssetInventoryExpenseProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteAssetInventoryExpenseProof(requestParameters: DeleteAssetInventoryExpenseProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    deleteAssetInventoryIncomeProofRaw(requestParameters: DeleteAssetInventoryIncomeProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteAssetInventoryIncomeProof(requestParameters: DeleteAssetInventoryIncomeProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    deleteAssetInventoryOwnClaimDocumentRaw(requestParameters: DeleteAssetInventoryOwnClaimDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteAssetInventoryOwnClaimDocument(requestParameters: DeleteAssetInventoryOwnClaimDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {AssetDocumentArea} area 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    getAssetInventoryAssetDocumentsRaw(requestParameters: GetAssetInventoryAssetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetInventoryDocumentResponse>>>;

    /**
     */
    getAssetInventoryAssetDocuments(requestParameters: GetAssetInventoryAssetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetInventoryDocumentResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    getAssetInventoryBankStatementsRaw(requestParameters: GetAssetInventoryBankStatementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetInventoryDocumentResponse>>>;

    /**
     */
    getAssetInventoryBankStatements(requestParameters: GetAssetInventoryBankStatementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetInventoryDocumentResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    getAssetInventoryDependantDocumentsRaw(requestParameters: GetAssetInventoryDependantDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetInventoryDocumentResponse>>>;

    /**
     */
    getAssetInventoryDependantDocuments(requestParameters: GetAssetInventoryDependantDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetInventoryDocumentResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    getAssetInventoryExpenseProofsRaw(requestParameters: GetAssetInventoryExpenseProofsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetInventoryDocumentResponse>>>;

    /**
     */
    getAssetInventoryExpenseProofs(requestParameters: GetAssetInventoryExpenseProofsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetInventoryDocumentResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    getAssetInventoryIncomeProofsRaw(requestParameters: GetAssetInventoryIncomeProofsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetInventoryDocumentResponse>>>;

    /**
     */
    getAssetInventoryIncomeProofs(requestParameters: GetAssetInventoryIncomeProofsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetInventoryDocumentResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    getAssetInventoryOwnClaimDocumentsRaw(requestParameters: GetAssetInventoryOwnClaimDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetInventoryDocumentResponse>>>;

    /**
     */
    getAssetInventoryOwnClaimDocuments(requestParameters: GetAssetInventoryOwnClaimDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetInventoryDocumentResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} documentId 
     * @param {MarkAssetInventoryDocumentReadRequest} markAssetInventoryDocumentReadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    markAssetInventoryDocumentReadRaw(requestParameters: MarkAssetInventoryDocumentReadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    markAssetInventoryDocumentRead(requestParameters: MarkAssetInventoryDocumentReadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {AssetDocumentArea} area 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    uploadAssetInventoryAssetDocumentRaw(requestParameters: UploadAssetInventoryAssetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryDocumentResponse>>;

    /**
     */
    uploadAssetInventoryAssetDocument(requestParameters: UploadAssetInventoryAssetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryDocumentResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    uploadAssetInventoryBankStatementRaw(requestParameters: UploadAssetInventoryBankStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryDocumentResponse>>;

    /**
     */
    uploadAssetInventoryBankStatement(requestParameters: UploadAssetInventoryBankStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryDocumentResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    uploadAssetInventoryDependantDocumentRaw(requestParameters: UploadAssetInventoryDependantDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponse>>;

    /**
     */
    uploadAssetInventoryDependantDocument(requestParameters: UploadAssetInventoryDependantDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    uploadAssetInventoryExpenseProofRaw(requestParameters: UploadAssetInventoryExpenseProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryDocumentResponse>>;

    /**
     */
    uploadAssetInventoryExpenseProof(requestParameters: UploadAssetInventoryExpenseProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryDocumentResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    uploadAssetInventoryIncomeProofRaw(requestParameters: UploadAssetInventoryIncomeProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryDocumentResponse>>;

    /**
     */
    uploadAssetInventoryIncomeProof(requestParameters: UploadAssetInventoryIncomeProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryDocumentResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetInventoryDocumentsApiInterface
     */
    uploadAssetInventoryOwnClaimDocumentRaw(requestParameters: UploadAssetInventoryOwnClaimDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryDocumentResponse>>;

    /**
     */
    uploadAssetInventoryOwnClaimDocument(requestParameters: UploadAssetInventoryOwnClaimDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryDocumentResponse>;

}

/**
 * 
 */
export class AssetInventoryDocumentsApi extends runtime.BaseAPI implements AssetInventoryDocumentsApiInterface {

    /**
     */
    async deleteAssetInventoryAssetDocumentRaw(requestParameters: DeleteAssetInventoryAssetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling deleteAssetInventoryAssetDocument().'
            );
        }

        if (requestParameters['area'] == null) {
            throw new runtime.RequiredError(
                'area',
                'Required parameter "area" was null or undefined when calling deleteAssetInventoryAssetDocument().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling deleteAssetInventoryAssetDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/asset-documents/{area}/{documentId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"area"}}`, encodeURIComponent(String(requestParameters['area'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAssetInventoryAssetDocument(requestParameters: DeleteAssetInventoryAssetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssetInventoryAssetDocumentRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteAssetInventoryBankStatementRaw(requestParameters: DeleteAssetInventoryBankStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling deleteAssetInventoryBankStatement().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling deleteAssetInventoryBankStatement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/bank-statements/{documentId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAssetInventoryBankStatement(requestParameters: DeleteAssetInventoryBankStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssetInventoryBankStatementRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteAssetInventoryDependantDocumentRaw(requestParameters: DeleteAssetInventoryDependantDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling deleteAssetInventoryDependantDocument().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling deleteAssetInventoryDependantDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/dependants/documents/{documentId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAssetInventoryDependantDocument(requestParameters: DeleteAssetInventoryDependantDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssetInventoryDependantDocumentRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteAssetInventoryExpenseProofRaw(requestParameters: DeleteAssetInventoryExpenseProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling deleteAssetInventoryExpenseProof().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling deleteAssetInventoryExpenseProof().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/expense-proofs/{documentId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAssetInventoryExpenseProof(requestParameters: DeleteAssetInventoryExpenseProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssetInventoryExpenseProofRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteAssetInventoryIncomeProofRaw(requestParameters: DeleteAssetInventoryIncomeProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling deleteAssetInventoryIncomeProof().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling deleteAssetInventoryIncomeProof().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/income-proofs/{documentId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAssetInventoryIncomeProof(requestParameters: DeleteAssetInventoryIncomeProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssetInventoryIncomeProofRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteAssetInventoryOwnClaimDocumentRaw(requestParameters: DeleteAssetInventoryOwnClaimDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling deleteAssetInventoryOwnClaimDocument().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling deleteAssetInventoryOwnClaimDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/own-claim-documents/{documentId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAssetInventoryOwnClaimDocument(requestParameters: DeleteAssetInventoryOwnClaimDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssetInventoryOwnClaimDocumentRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAssetInventoryAssetDocumentsRaw(requestParameters: GetAssetInventoryAssetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetInventoryDocumentResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAssetInventoryAssetDocuments().'
            );
        }

        if (requestParameters['area'] == null) {
            throw new runtime.RequiredError(
                'area',
                'Required parameter "area" was null or undefined when calling getAssetInventoryAssetDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/asset-documents/{area}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"area"}}`, encodeURIComponent(String(requestParameters['area'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetInventoryDocumentResponseFromJSON));
    }

    /**
     */
    async getAssetInventoryAssetDocuments(requestParameters: GetAssetInventoryAssetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetInventoryDocumentResponse>> {
        const response = await this.getAssetInventoryAssetDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssetInventoryBankStatementsRaw(requestParameters: GetAssetInventoryBankStatementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetInventoryDocumentResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAssetInventoryBankStatements().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/bank-statements`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetInventoryDocumentResponseFromJSON));
    }

    /**
     */
    async getAssetInventoryBankStatements(requestParameters: GetAssetInventoryBankStatementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetInventoryDocumentResponse>> {
        const response = await this.getAssetInventoryBankStatementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssetInventoryDependantDocumentsRaw(requestParameters: GetAssetInventoryDependantDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetInventoryDocumentResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAssetInventoryDependantDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/dependants/documents`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetInventoryDocumentResponseFromJSON));
    }

    /**
     */
    async getAssetInventoryDependantDocuments(requestParameters: GetAssetInventoryDependantDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetInventoryDocumentResponse>> {
        const response = await this.getAssetInventoryDependantDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssetInventoryExpenseProofsRaw(requestParameters: GetAssetInventoryExpenseProofsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetInventoryDocumentResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAssetInventoryExpenseProofs().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/expense-proofs`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetInventoryDocumentResponseFromJSON));
    }

    /**
     */
    async getAssetInventoryExpenseProofs(requestParameters: GetAssetInventoryExpenseProofsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetInventoryDocumentResponse>> {
        const response = await this.getAssetInventoryExpenseProofsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssetInventoryIncomeProofsRaw(requestParameters: GetAssetInventoryIncomeProofsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetInventoryDocumentResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAssetInventoryIncomeProofs().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/income-proofs`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetInventoryDocumentResponseFromJSON));
    }

    /**
     */
    async getAssetInventoryIncomeProofs(requestParameters: GetAssetInventoryIncomeProofsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetInventoryDocumentResponse>> {
        const response = await this.getAssetInventoryIncomeProofsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssetInventoryOwnClaimDocumentsRaw(requestParameters: GetAssetInventoryOwnClaimDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetInventoryDocumentResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAssetInventoryOwnClaimDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/own-claim-documents`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetInventoryDocumentResponseFromJSON));
    }

    /**
     */
    async getAssetInventoryOwnClaimDocuments(requestParameters: GetAssetInventoryOwnClaimDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetInventoryDocumentResponse>> {
        const response = await this.getAssetInventoryOwnClaimDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async markAssetInventoryDocumentReadRaw(requestParameters: MarkAssetInventoryDocumentReadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling markAssetInventoryDocumentRead().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling markAssetInventoryDocumentRead().'
            );
        }

        if (requestParameters['markAssetInventoryDocumentReadRequest'] == null) {
            throw new runtime.RequiredError(
                'markAssetInventoryDocumentReadRequest',
                'Required parameter "markAssetInventoryDocumentReadRequest" was null or undefined when calling markAssetInventoryDocumentRead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/asset-inventory/documents/{documentId}/read`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: MarkAssetInventoryDocumentReadRequestToJSON(requestParameters['markAssetInventoryDocumentReadRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async markAssetInventoryDocumentRead(requestParameters: MarkAssetInventoryDocumentReadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.markAssetInventoryDocumentReadRaw(requestParameters, initOverrides);
    }

    /**
     */
    async uploadAssetInventoryAssetDocumentRaw(requestParameters: UploadAssetInventoryAssetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryDocumentResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling uploadAssetInventoryAssetDocument().'
            );
        }

        if (requestParameters['area'] == null) {
            throw new runtime.RequiredError(
                'area',
                'Required parameter "area" was null or undefined when calling uploadAssetInventoryAssetDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/asset-documents/{area}/upload`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"area"}}`, encodeURIComponent(String(requestParameters['area'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetInventoryDocumentResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadAssetInventoryAssetDocument(requestParameters: UploadAssetInventoryAssetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryDocumentResponse> {
        const response = await this.uploadAssetInventoryAssetDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadAssetInventoryBankStatementRaw(requestParameters: UploadAssetInventoryBankStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryDocumentResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling uploadAssetInventoryBankStatement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/bank-statements/upload`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetInventoryDocumentResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadAssetInventoryBankStatement(requestParameters: UploadAssetInventoryBankStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryDocumentResponse> {
        const response = await this.uploadAssetInventoryBankStatementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadAssetInventoryDependantDocumentRaw(requestParameters: UploadAssetInventoryDependantDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling uploadAssetInventoryDependantDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/dependants/documents/upload`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadAssetInventoryDependantDocument(requestParameters: UploadAssetInventoryDependantDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponse> {
        const response = await this.uploadAssetInventoryDependantDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadAssetInventoryExpenseProofRaw(requestParameters: UploadAssetInventoryExpenseProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryDocumentResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling uploadAssetInventoryExpenseProof().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/expense-proofs/upload`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetInventoryDocumentResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadAssetInventoryExpenseProof(requestParameters: UploadAssetInventoryExpenseProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryDocumentResponse> {
        const response = await this.uploadAssetInventoryExpenseProofRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadAssetInventoryIncomeProofRaw(requestParameters: UploadAssetInventoryIncomeProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryDocumentResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling uploadAssetInventoryIncomeProof().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/income-proofs/upload`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetInventoryDocumentResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadAssetInventoryIncomeProof(requestParameters: UploadAssetInventoryIncomeProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryDocumentResponse> {
        const response = await this.uploadAssetInventoryIncomeProofRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadAssetInventoryOwnClaimDocumentRaw(requestParameters: UploadAssetInventoryOwnClaimDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetInventoryDocumentResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling uploadAssetInventoryOwnClaimDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/asset-inventory/own-claim-documents/upload`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetInventoryDocumentResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadAssetInventoryOwnClaimDocument(requestParameters: UploadAssetInventoryOwnClaimDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetInventoryDocumentResponse> {
        const response = await this.uploadAssetInventoryOwnClaimDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
